import styled from '@emotion/styled'

export const SettingsContextSwitcherWrapper = styled.div`
  width: 100%;
`
